import { isPlatformBrowser } from '@angular/common';

export namespace BrowserDetection {
    declare interface TestWindow extends Window {
        HTMLElement: any;
    }
    export function getBrowser(testWindow: TestWindow): string {
        let browser = 'bot';
        let isOpera: boolean;
        let isFirefox: boolean;
        let isSafari: boolean;
        let isIE: boolean;
        let isEdge: boolean;
        let isChrome: boolean;
        let isEdgeChromium: boolean;
        let isBlink: boolean;
        // tslint:disable: no-string-literal
        // tslint:disable: max-line-length
        try {
            // Opera 8.0+
            isOpera = (!!testWindow['opr'] && !!testWindow['opr'].addons) || !!testWindow['opera'] || navigator.userAgent.indexOf(' OPR/') >= 0;
            browser = isOpera ? 'opera' : browser;
        } catch {}
        try {
            // Firefox 1.0+
            isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
            browser = isFirefox ? 'firefox' : browser;
        } catch {}
        try {
            // Safari 3.0+ "[object HTMLElementConstructor]"
            isSafari = /constructor/i.test(testWindow.HTMLElement) || (p => p.toString() === '[object SafariRemoteNotification]')(!testWindow['safari'] || (typeof testWindow['safari'] !== 'undefined' && testWindow['safari'].pushNotification));
            browser = isSafari ? 'safari' : browser;
        } catch {}
        try {
            // Internet Explorer 6-11
            isIE = /*@cc_on!@*/false || !!document['documentMode'];
            browser = isIE ? 'ie' : browser;
        } catch {}
        try {
            // Edge 20+
            isEdge = !isIE && !!testWindow['StyleMedia'];
            browser = isEdge ? 'edge' : browser;
        } catch {}
        try {
            // Chrome 1 - 79
            isChrome = !!testWindow['chrome'] && (!!testWindow['chrome'].webstore || !!testWindow['chrome'].runtime);
            browser = isChrome ? 'chrome' : browser;
        } catch {}
        try {
            // Edge (based on chromium) detection
            isEdgeChromium = isChrome && (navigator.userAgent.indexOf('Edg') !== -1);
            browser = isEdgeChromium ? 'edge' : browser;
        } catch {}
        try {
            // Blink engine detection
            isBlink = (isChrome || isOpera) && !!testWindow['CSS'];
            browser = isBlink ? 'blink' : browser;
        } finally {}
        // tslint:enable: no-string-literal
        // tslint:enable: max-line-length
        return browser;
    }

    export function isBrowser(platformId: string): boolean {
        return isPlatformBrowser(platformId) && isPrerender() === false;
    }

    export function isPrerender(): boolean {
        return window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('(+https://github.com/prerender/prerender)') >= 0;
    }

    export function getPointer(): 'coarse' | 'fine' | 'none' {
        let match: 'coarse' | 'fine' | 'none';
        try {
            match = window.matchMedia('(pointer: coarse)').matches ? 'coarse' : match;
            match = window.matchMedia('(pointer: fine)').matches ? 'fine' : match;
            match = window.matchMedia('(pointer: none)').matches ? 'none' : match;
        } finally {}
        return match;
    }

    export function getHoverbility(): boolean | undefined {
        let hasHover;
        let hasNoHover;
        try {
            hasHover = window.matchMedia('(any-hover: hover)').matches || window.matchMedia('(hover: hover)').matches;
            hasNoHover = window.matchMedia('(any-hover: none)').matches || window.matchMedia('(hover: none)').matches;
        } finally {}
        return hasHover === true ? true : (hasNoHover === false ? false : undefined);
    }

    export async function getIP(): Promise<string> {
        return (await (await fetch('https://api.ipify.org/?format=json')).json()).then((data: { ip: string }) => data.ip)
    }

    export function getPlatform(): string {
        return window.navigator.platform;
    }


    export function isIncognito(): Promise<boolean> {
        return new Promise((resolve, reject) => {
            try {
                // tslint:disable-next-line: no-string-literal
                const fileSystem = window['RequestFileSystem'] || window['webkitRequestFileSystem'];

                if (fileSystem == null) {
                    resolve(false);
                } else {
                    // tslint:disable-next-line: no-string-literal
                    fileSystem(window['TEMPORARY'],
                        100,
                        resolve(false),
                        resolve(true)
                    );
                }
            } catch (error) {
                reject(error);
            }
        });
    }
}
